// extracted by mini-css-extract-plugin
export default {"cta":"waa","grey":"xaa","dark":"yaa","chip":"zaa","card":"Aaa","nonclickable":"Baa","top":"Caa","left":"Eaa","span":"Faa","name":"Gaa"};
    if(module.hot) {
      // 1726593108415
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  